<tgt-modal [witdhModal]="'80%'">

  <div class="content">

    <div class="header">
      <p>Política de Privacidade – Escolar AI</p>
      <span class="material-symbols-outlined" (click)="fechar()">
        close
      </span>
    </div>

    <main class="terms-container">
      <p>
        A Escolar AI, pessoa jurídica de direito privado, leva a sua privacidade a sério e zela pela segurança e proteção
        dos dados pessoais de todos os usuários da plataforma <strong>www.escolarai.com</strong>, incluindo escolas,
        secretarias, professores, alunos, pais ou responsáveis.
      </p>

      <p>
        Esta Política de Privacidade informa como utilizamos e protegemos as informações coletadas por meio da plataforma
        Escolar AI.
      </p>

      <p class="highlight">
        <strong>AO ACESSAR A PLATAFORMA OU FORNECER QUALQUER DADO PESSOAL, VOCÊ CONCORDA COM OS TERMOS DESTA POLÍTICA DE PRIVACIDADE.</strong>
      </p>

      <p>Para dúvidas, entre em contato através do e-mail <a href="mailto:atendimento@escolarai.com">{{this.email}}</a>.</p>

      <h2>Seção 1 – Definições</h2>
      <ul class="terms-list">
        <li><strong>“Dados Pessoais”:</strong> informações que identificam ou possam identificar uma pessoa natural (nome, CPF, foto do aluno, endereço IP, etc.).</li>
        <li><strong>“Tratamento de Dados Pessoais”:</strong> operações realizadas com Dados Pessoais (coleta, armazenamento, utilização, etc.) conforme a LGPD (Lei nº 13.709/18).</li>
      </ul>

      <h2>Seção 2 – Uso dos Dados Pessoais</h2>
      <p>A Escolar AI coleta e usa Dados Pessoais para:</p>
      <ul class="terms-list">
        <li>Gerenciar a presença automática dos alunos utilizando integração com câmeras (sem retenção ou armazenamento das imagens captadas);</li>
        <li>Enviar notificações automáticas aos pais sobre presenças e faltas;</li>
        <li>Permitir à escola/secretaria a gestão de relatórios de notas, presenças, conteúdos ministrados, envio de e-mails aos pais e agendamento de eventos;</li>
        <li>Permitir aos professores a inclusão e gestão das aulas e conteúdos ministrados;</li>
        <li>Permitir aos pais ou responsáveis acessar o histórico escolar completo dos seus filhos;</li>
        <li>Cumprir determinações legais ou judiciais;</li>
        <li>Garantir segurança e proteção da plataforma e dos usuários;</li>
        <li>Detectar e prevenir fraudes.</li>
      </ul>

      <p>Ao enviar Dados Pessoais de terceiros, você declara ter a competência e o consentimento necessário.</p>

      <h2>Seção 3 – Não fornecimento dos Dados</h2>
      <p>Não fornecer os Dados Pessoais pode impossibilitar o acesso integral às funcionalidades da plataforma Escolar AI.</p>

      <h2>Seção 4 – Dados coletados</h2>
      <ul class="terms-list">
        <li><strong>Alunos:</strong> nome, foto, CPF, histórico escolar;</li>
        <li><strong>Responsáveis:</strong> nome, e-mail, telefone;</li>
        <li><strong>Funcionários e professores:</strong> nome, e-mail, disciplinas ministradas;</li>
        <li><strong>Dados técnicos:</strong> IP, navegador, dispositivo.</li>
      </ul>

      <h2>Seção 5 – Compartilhamento de Dados</h2>
      <p>Os dados são acessados apenas pela escola autorizada e responsáveis. Não há compartilhamento com terceiros sem autorização, exceto por obrigação legal.</p>

      <h2>Seção 6 – Transferências Internacionais</h2>
      <p>Não realizamos transferências internacionais. Os dados são tratados e armazenados no Brasil, conforme a LGPD.</p>

      <h2>Seção 7 – Coleta Automática</h2>
      <p>Utilizamos cookies para melhorar a experiência do usuário. As imagens captadas para presença não são armazenadas.</p>

      <h2>Seção 8 – Segurança dos Dados</h2>
      <p>Aplicamos medidas técnicas e administrativas para proteger os Dados Pessoais contra acessos não autorizados e vazamentos.</p>

      <h2>Seção 9 – Direitos dos Usuários</h2>
      <p>Você pode exercer seus direitos previstos na LGPD entrando em contato via <a href="mailto:atendimento@escolarai.com">{{this.email}}</a>.</p>

      <h2>Seção 10 – Atualizações da Política</h2>
      <p>Esta política pode ser atualizada a qualquer momento e a versão atual estará disponível na plataforma.</p>

      <h2>Seção 11 – Contato</h2>
      <p>Para esclarecimentos, contate-nos: <a href="mailto:atendimento@escolarai.com">{{this.email}}</a>.</p>

      <p class="thank-you">Obrigado por confiar em nós!</p>
    </main>
  </div>
  <div class="actions">
    <tgt-button [size]="'small'" [border]="false" (click)="fechar()" [fieldButton]="'outline'">Fechar</tgt-button>
  </div>
</tgt-modal>
